export const APP_CONSTANTS ={
    ROUTES: {
        HOME: "/",
        MEASURES_TAKING: "/measuresTaking",
        INSTANT_TELE_EXPERTISE: "/instantTeleExpertise",
        PATIENTS_LIST: "/patients",
        ADD_PATIENT: "/addPatient",
        PATIENT_RECORD: "/patients",
        USERS_MANAGEMENT: "/users",
        CENTERS_MANAGEMENT: "/centers",
        SETTINGS: "/settings",
        CALENDAR: "/calendar",
        MY_SCORE_AI: "/myScoreAi",
        EYE_CHART: "/eyeChart",
        GUIDELINES_TO_FOLOW: "/guidelinesToFolow",
        CODEX: "/codex",
        PRESCRIPTIONS: "/prescriptions",
        DRUGS_INTERACTIONS: "/drugsInteractions",
        SYMPTOMATOR: "/symptomator",
        MY_SKIN_AI: "/mySkinAI",
        WAITING_LIST: "/waitingList",
        AI_TOOLS: "/aiTools",
        LOCAL_CONSULTATION: "/consultation",
        INCOMINGCALL: "/doctor/call",
        LOGIN: "login",
        ROOM: "/room",
        DEVICES_WITHOUT_AUTHENTICATION: "/no-auth/devices",
        BASIC_DEVICES_WITHOUT_AUTHENTICATION: "/no-auth/basicDevices",
        ADVANCED_DEVICES_WITHOUT_AUTHENTICATION_AI: "/no-auth/advancedDevices/ai",
        ADVANCED_DEVICES_WITHOUT_AUTHENTICATION: "/no-auth/advancedDevices",
        USAGE_GUIDE: "/docs",
        SUPPORT: "/support",
      },
     TABLES: {
        users: {
          headers: [
            { key: "lastName", keyTranslate: "lastName", label: "Nom" },
            {
              key: "firstName",
              keyTranslate: "firstName",
              label: "Prénom",
            },

         
            { key: "credential.login", keyTranslate: "Login", label: "Login" },
            {
              key: "doctor.speciality.name",
              keyTranslate: "speciality",
              label: "Profession",
            },
 
            {
              key: "phoneNumber",
              keyTranslate: "phoneNumber",
              label: "Téléphone",
            },
            
          ],
          limit: 10,
        },
        centers:{
          headers:[
            { 
              key: "name", 
              keyTranslate: "center", 
              label: "Centre" 
            },
            { 
              key: "city.name", 
              keyTranslate: "city", 
              label: "Ville" 
            },
            { 
              key: "city.province.name", 
              keyTranslate: "province", 
              label: "Province" 
            },
            { 
              key: "city.province.region.name", 
              keyTranslate: "region", 
              label: "Region" 
            },
            { 
              key: "address", 
              keyTranslate: "address", 
              label: "Address" 
            },
          ],
          limit: 10,
        }

      },
      LOCALSTORAGE_PREFIX:'vs_'
}